import type { OrganizationProfile } from '@chukua/common';

/** The tenant logo for a light or dark surface; a dark surface falls back to the light logo when there's no dark variant. */
export function pickLogo(profile: OrganizationProfile, surface: 'light' | 'dark'): string | null {
  if (surface === 'dark') return profile.logoDarkUrl ?? profile.logoUrl;
  return profile.logoUrl;
}
